/* eslint-disable */
import * as React from "react";
import { SlideContext } from "../Context";
import { ComponentTitle } from "../../../components/ComponentTitle";
import { ComponentSourcetitle } from "../../../components/ComponentSourcetitle";
import { ComponentPreloader } from "../../../components/ComponentPreloader";
import { useTableData } from "../data/useTableData";
import { useAgGridTransformer } from "../transformers/useAgGridTransformer";
import { useHookSubscribe } from "../../../shared/hooks/hookSubscribe";
import { ComponentContextReadyState } from "@sa/rep-core";
import { Table } from "../../../components/Table";
import { debounceTime } from "rxjs/operators";
import { useExportSource } from "../hooks/useExportSource";
import { useTableTitle } from "../hooks/useTableTitle";
import "./component-table.css";
import { useSubscriptionSource } from "../../../shared";

export const ComponentTable: React.FC<{ context: SlideContext }> = (props) => {
  const context = props.context;
  const olapResult = useHookSubscribe(null, context.olapResult$.pipe<any>(debounceTime(300)));
  const source = useHookSubscribe(null, context.sources$);
  const loading = useHookSubscribe(null, context.loading$);

  const footnote = useTableTitle();

  const tableData = useTableData(olapResult);
  const agGridData = useAgGridTransformer(tableData);

  useExportSource(source);
  useSubscriptionSource(source);

  if (window["exportMode"]) {
    window["exportReady"] = agGridData && context.readyState !== ComponentContextReadyState.Loading;
  }
  if (loading) {
    return <ComponentPreloader />;
  }

  return (
    <>
      <ComponentTitle>{footnote}</ComponentTitle>
      <ComponentSourcetitle>Source: {source}</ComponentSourcetitle>
      <div className="custom-table-slide35-box">
        {agGridData ? <Table className="custom-table-slide35" {...agGridData} /> : <ComponentPreloader />}
      </div>
    </>
  );
};
